import { render, staticRenderFns } from "./ProductTopupTip.vue?vue&type=template&id=07e70acd&scoped=true&"
import script from "./ProductTopupTip.vue?vue&type=script&lang=js&"
export * from "./ProductTopupTip.vue?vue&type=script&lang=js&"
import style0 from "./ProductTopupTip.vue?vue&type=style&index=0&id=07e70acd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e70acd",
  null
  
)

component.options.__file = "ProductTopupTip.vue"
export default component.exports